'use strict'

const React = require('react')
const _ = require('lodash')
const MeshReact = require('santa-mesh/cjs/src/MeshReact')
const createReactElement = require('../../utils/createReactElement')
const styleRenderer = require('../StyleRenderer/StyleRenderer')

const getGridVariant = browser => browser.ie ? 'ms' : 'standard'
const getChildId = comp => comp.props.id
const getMeshStyles = id => stylesMap => styleRenderer({
    id: `${id}-mesh-styles`,
    stylesMap: _.merge(
        stylesMap, {
            [`${id}inlineContent`]: {
                position: 'relative'
            },
            [`${id}centeredContent`]: {
                position: 'relative'
            }
        }
    )
})

const SantaMesh = ({container, contentArea, adjustingId, browser, fixedChildrenIDs, children, filterChildren = () => true}) => {
    const fixedChildrenMap = fixedChildrenIDs.map(id => ({[id]: true})).reduce(_.assign, {})
    const filteredChildrenArray = React.Children.toArray(children).filter(_.flow(getChildId, filterChildren))
    const isReactChildFixed = comp => !!fixedChildrenMap[getChildId(comp)]
    const [fixedChildren, notFixedChildren] = _.partition(filteredChildrenArray, isReactChildFixed)
    const modifiedContainer = Object.assign(
        {},
        container, {
            id: `${container.id}inlineContent`,
            components: container.components.filter(comp => !comp.isFixed && filterChildren(comp.id))
        },
        contentArea && {width: '100%', contentArea}
    )

    return [
        ...fixedChildren,
        createReactElement(
            MeshReact.default,
            {
                container: modifiedContainer,
                adjustingId,
                key: `${container.id}-MeshReact`,
                getChildId,
                options: {cssGridVariant: getGridVariant(browser)},
                getStyle: getMeshStyles(container.id)
            },
            notFixedChildren
        )
    ]
}

module.exports = SantaMesh